import { render, staticRenderFns } from "./nomina-table.vue?vue&type=template&id=692cd490&"
import script from "./nomina-table.vue?vue&type=script&lang=ts&"
export * from "./nomina-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports